import { render, staticRenderFns } from "./activityVideo.vue?vue&type=template&id=15e87070&scoped=true"
import script from "./activityVideo.vue?vue&type=script&lang=js"
export * from "./activityVideo.vue?vue&type=script&lang=js"
import style0 from "./activityVideo.vue?vue&type=style&index=0&id=15e87070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e87070",
  null
  
)

export default component.exports